import { QuestionStep } from '../QuestionStep';
import { ChoiceGrid } from './_shared';
import {
  LAYOUT_STYLE_OPTIONS,
  BRAND_TONE_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface StyleStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function StyleStep({ answers, onChange }: StyleStepProps) {
  const step = STEPS.find((s) => s.id === 'style')!;

  return (
    <QuestionStep step={step}>
      <div className="grid gap-10">
        <div>
          <p className="smallcaps mb-3 text-graphite">Layout density</p>
          <ChoiceGrid
            options={LAYOUT_STYLE_OPTIONS}
            value={answers.layout_style}
            onChange={(v) => onChange({ layout_style: v })}
            columns={3}
          />
        </div>

        <div>
          <p className="smallcaps mb-3 text-graphite">Brand tone</p>
          <ChoiceGrid
            options={BRAND_TONE_OPTIONS}
            value={answers.brand_tone}
            onChange={(v) => onChange({ brand_tone: v })}
            columns={3}
          />
        </div>
      </div>
    </QuestionStep>
  );
}
